import { Phrases } from '@shared/model/locales.model';

export default {
  EditGateToGate: {
    EditTime: 'Edit Time',
    ConfirmEdit: 'Modify and confirm that you are sure to make this change.',
    AccurateTime: 'Accurate Time',
  },
  GateDefinition: {
    inBound: 'In-bound',
    outBound: 'Out-bound',
    both: 'Both',
    temperatureControl: 'Temperature Control',
    temperatureControlText: 'If not selected it means that the gate temperature is normal.',
    gateName: 'Gate Name',
    referenceID: 'Reference ID',
    truckClassify: 'Truck Classify',
    Frozen: 'Frozen',
    Chiller: 'Chiller',
    GatesManagement: 'Gates Management',
    addGateDesc: 'Click "Add Gate" to configure location gates',
    addGate: 'Add Gate',
    gates: 'Gates',
    DeviceDistance: 'Device distance',
  },
  GateToGate: {
    DateModifyingHistory: 'Date Modifying History',
    DateUpdated: '* By [{{name}}], was [{{date}}]',
    ShipmentLogs: 'Shipment Logs',
    SentEmail: 'Email sent',
    WithAttachment: 'with Attachments',
  },

  ShippingCard: {
    Clients: 'Clients',
    Orders: 'Orders',
  },
  deliveryNote: {
    uploadWaitingCharge: 'Upload Waiting Charge Proof',
  },
  PlateNumber: {
    External: 'External',
  },
  StatusCard: {
    NoteThatOverdueDays: 'Note that Overdue days for invoices are updated at 01:00 AM every day.',
  },
  Enum: {
    WccIntegrationStatusType: {
      WAITING_ASSIGNMENT: 'Waiting Assignment',
      INTEGRATED: 'Integrated',
      INTEGRATION_FAILED: 'Integration Failed',
      INTEGRATION_IN_PROGRESS: 'Integration in Progress',
      INTEGRATION_CANCELED: 'Integration canceled',
      CANCELATION_FAILED: 'Integration failed',
    },
    ShipmentHeadedStatus: {
      RIGHT_HEADED: 'Right Headed',
      WRONG_HEADED: 'Wrong Headed',
    },
  },
  usersList: {
    button: {
      generateComplexPassword: 'Generate Complex Password',
    },
  },

  'ShipmentAssignment.OverrideDetected': 'Override detected',
  'ShipmentAssignment.Kindly': 'kindly know that ',
  'ShipmentAssignment.TheDriver': 'the driver ',
  'ShipmentAssignment.TheTruck': 'the truck ',
  'ShipmentAssignment.HasRunningShipment': 'has a running shipment ',
  'ShipmentAssignment.From': ' From ',
  'ShipmentAssignment.To': 'To',
  'ShipmentAssignment.CloseShipment': 'would you like to hard close ',
  'ShipmentAssignment.ThisShipment': 'This shipment',
  'ShipmentAssignment.ThoseShipments': 'Those shipments',
  'ShipmentAssignment.WillStart': ' will start once',
  'ShipmentAssignment.Shipment': 'shipment',
  'ShipmentAssignment.Is': 'is',
  'ShipmentAssignment.Are': 'are',
  'ShipmentAssignment.SuccessfullyDelivered': ' successfully delivered',
  'ShipmentAssignment.ConfirmOverride': 'Confirm Override',
  'ShipmentAssignment.JustAssign': 'Just Assign',
  'ShipmentAssignment.AssignAndAutoStart': 'Assign and Auto-start',
  'ShipmentAssignment.Justification': 'Justification',
  'ShipmentAssignment.ErrorMessageRequired': ' Required',
  'ShipmentAssignment.Hint': 'Hint',

  'Orders.AllOrdersWithCount': 'All {{count}} Orders',
  'Orders.PalletsWithCount': 'Pallets {{count}}',
  'Orders.ItemsWithCount': 'Items {{count}}',
  'Orders.CreatedAt': 'Created At',
  'Orders.Pallets': 'Pallets',
  'Orders.Items': 'Items',
  'OrderType.StockToCustomerStock': 'Stock Transfer',
  'OrderType.StoTransfer': 'Stock Transfer',
  'OrderType.Z122': 'Stock Transfer',
  'OrderType.MOIR': 'MOI-R',
  'OrderType.ZPG1': 'ZPG1',
  'OrderType.CustomerOutboundOrders': 'Outbound Transfer',
  'OrderType.CustomerReturn': 'Customer Return',
  'OrderType.CustomerReturnNupcoStock': 'Customer Return Nupco Stock',
  'OrderType.NupcoSalesReturns': 'Nupco Sales Returns',
  'OrderType.DistributionOutboundOrder': 'Distribution Outbound Order',
  'OrderType.TransferOrders': 'Transfer Orders',
  'OrderType.VendorSupplierReturns': 'Vendor Supplier Returns',
  'OrderType.SalesOrder': 'Sales Order',
  'OrderType.NupcoRoyalCourt': 'Nupco Royal Court',
  'OrderType.NupcoDonationIssue': 'Nupco Donation Issue',
  'OrderType.ScrapOrders': 'Scrap Orders',
  'OrderType.PrepareOrder': 'Prepare Order',
  'OrderType.SalesWithPrice': 'Sales With Price',
  CancelAll: 'Cancel All',
  NoOrdersAddedYet: 'No orders added yet',
  'UserStatus.ACTIVE': 'Active',
  'UserStatus.INACTIVE': 'Inactive',
  'UserStatus.All': 'All',
  PricingMethod: 'Pricing Method',
  SelectUnitType: 'Select Unit Type',
  PER_TRADE_LANE: 'By Tradelane',
  PER_UNIT: 'By Unit',
  TON: 'Ton',
  ZeroPrices: 'Zero Shipment Prices',
  UseZeroPrices: 'Use zero shipment prices',
  UseDefaultPrices: 'Use default shipping prices',
  CustomerPartOfOrganization:
    "This customer is part of an organization, you can't change the pricing method.",
  ConfirmationChangePricingMethod: 'Are you sure you want to change it?',
  ConfirmationMessageChangePricingMethod:
    "You're about to switch the payment method from {{pricingMethodBefore}} to {{pricingMethodAfter}}. This change will update all tradelane pricing for the entity.",
  YesChange: 'Yes, Change',
  KeepCurrent: 'Keep Current',
  CustomerType: 'Customer Type',
  Saas: 'SaaS',
  Taas: 'TaaS',
  Both: 'Both',
  SaaSFees: 'SaaS Fees',
  SearchUser: 'User Name or Email',
  Aggregator: 'Aggregator',
  MovedTitle: 'B2C Admin Has Moved',
  Description:
    'The B2C management panel is now available on a separate platform. Please use the link below to access it.',
  LoginInfo: 'You can log in using the same email or phone number and password.',
  NewLocation: 'New Location',
  Url: 'lastmile.madar.app',
  BookmarkNote:
    'To continue enjoying uninterrupted access, please update your bookmarks and saved links.',
  GoButton: 'Go to B2C Admin',
  OpenNewTab: 'Open in new tab',
  Footer: 'This change was made to improve performance and user experience',
  RenewPasswordReminder: 'Renew Password Reminder',
  NoticeTitle: 'Notice: Your Password Will Expire Soon',
  NoticeBody:
    'Your password will expire in {{days}} days. You can renew at any time from your account settings.',
  ReminderTitle: 'Reminder: Your Password is Expiring Soon',
  ReminderBody:
    'Your password will expire in {{days}} days. We recommend renewing early to avoid interruptions.',
  UrgentTitle: 'Urgent: Your Password Expires Soon!',
  UrgentBodyDays:
    'Only {{days}} day(s) left before your password expires. Renew immediately to avoid interruption.',
  UrgentBodyExpired: 'Your password has expired. Renew now to restore access to all services.',
  DaysRemainingLabel: '{{days}} day(s) remaining',
  PasswordExpiredLabel: 'Password expired',
  Expired: 'Expired',
  DaysLeft: 'days left',
  RemindMeLater: 'Remind Me Later',
  RenewNow: 'Renew Password Now',
  WaitingChargeConfig: 'Waiting Charge Configuration',
  EnableWaitingTimeChargesPolicy: 'Enable Waiting Time Charges Policy',
  EnableWaitingTimeChargesPolicyDesc: 'Enable or disable waiting charges for pickup and drop-off delays.',
  FreeWaitingTime: 'Free Waiting Time',
  FreeWaitingTimeTooltip: 'Free waiting time before charges apply',
  HourlyRate: 'Hourly Rate',
  HourlyRateTooltip: 'Charge per hour after free time',
  MaximumWaitingHours: 'Maximum Waiting Hours',
  MaximumWaitingHoursTooltip: 'Max billable waiting hours before switching to daily rate',
  DailyRate: 'Daily Rate',
  DailyRateTooltip: 'Full day waiting charge',
  Hour: 'Hour',
  Export: 'Export',
  NoStatementsFound: 'No account statements found yet',
  TransactionDate: 'Transaction Date',
  ReferenceNumber: 'Reference Number',
  DueDate: 'Due Date',
  OverdueDays: 'Overdue Days',
  Debit: 'Debit',
  Credit: 'Credit',
  Status: 'Status',
} as Phrases;
